module.exports = __webpack_public_path__ + "static/img/logo_poweredby_zentek.4d8988f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_poweredby_zentek.svg
// module id = cPyC
// module chunks = 1